import { useEffect } from 'react'

const initializeLytics = () => {
  // prettier-ignore
  /* eslint-disable */
  !function(){"use strict";var o=window.jstag||(window.jstag={}); window.lyticsQueue = window.lyticsQueue || []; function n(e){o[e]=function(){for(var n=arguments.length,t=new Array(n),i=0;i<n;i++)t[i]=arguments[i];window.lyticsQueue.push([e,t])}}n("send"),n("mock"),n("identify"),n("pageView"),n("unblock"),n("getid"),n("setid"),n("loadEntity"),n("getEntity"),n("on"),n("once"),n("call")}();
  /* eslint-enable */
}

export const lytics = {
  sendEvent: (...args) => {
    initializeLytics()
    window.jstag.send(...args)
  },
}

const useLytics = lyticsId => {
  useEffect(() => {
    initializeLytics()
  }, [])

  useEffect(() => {
    if (lyticsId) {
      try {
        lytics.sendEvent({ email: lyticsId })
      } catch {
        return () => {}
      }
    }
  }, [lyticsId])
}

export default useLytics
